import React from 'react';
import Box from '@rexlabs/box';
import { Field } from '@rexlabs/form';
import { TextInput } from '@rexlabs/text-input';
import { FileInputZone } from 'view/components/file-input';
import { styled, StyleSheet } from '@rexlabs/styling';
import { Heading, Body } from '@rexlabs/text';

export const mapPropsToValues = (props) => {
  const { settings } = props;
  const settingsData = settings.list.items;

  const data = Object.assign(
    {},
    ...settingsData.map((object) => {
      switch (object.type) {
        case 'image':
          return {
            [object.key]: object?.value?.data
              ? object?.value.data
              : object?.value
          };
        default:
          return { [object.key]: object?.value ? object?.value[0] : null };
      }
    })
  );

  return data;
};

const defaultStyles = StyleSheet({
  fieldContainer: {
    padding: '10px 0'
  },
  subtitle: {
    color: '#676C7E'
  }
});

function MinimalSiteStylesSettings({ settings, styles: s }) {
  return (
    <Box>
      <Heading>Logo</Heading>

      <Body bold>Desktop</Body>
      <Box {...s('fieldContainer')}>
        <Field
          label='Desktop Logo (JPEG, PNG)'
          name='desktop_logo'
          Input={FileInputZone}
          inputProps={{
            settingKey: 'desktop_logo',
            category: settings?.list?.args?.category,
            type: 'image',
            acceptedTypes: ['image/png', 'image/jpg', 'image/jpeg'],
            acceptedExtensions: ['.png', '.jpg', '.jpeg']
          }}
          optional={false}
          HelpTooltipContent={() => 'Maximum file size is 5 MB.'}
        />
      </Box>

      <Body bold>Mobile</Body>

      <Box {...s('fieldContainer')}>
        <Field
          label='Mobile Logo (JPEG, PNG)'
          name='mobile_logo'
          Input={FileInputZone}
          inputProps={{
            settingKey: 'mobile_logo',
            category: settings?.list?.args?.category,
            type: 'image',
            acceptedTypes: ['image/png', 'image/jpg', 'image/jpeg'],
            acceptedExtensions: ['.png', '.jpg', '.jpeg']
          }}
          optional={false}
          HelpTooltipContent={() =>
            "If you don't require a separate mobile logo, the desktop logo will be used by default. Maximum file size is 5 MB."
          }
        />
      </Box>

      <Box {...s('fieldContainer')}>
        <Field
          label='Logo Alt text'
          name='logo_alt_text'
          Input={TextInput}
          optional={false}
          id={'logo-alt-text-field'}
        />
      </Box>
    </Box>
  );
}

export default styled(defaultStyles)(MinimalSiteStylesSettings);
